import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('BUBBLE_POP', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 8; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const dist = progress * 80;
    const x = e.pos.x + Math.cos(angle) * dist;
    const y = e.pos.y + Math.sin(angle) * dist;

    ctx.strokeStyle = determineColor(i, 8);
    ctx.globalAlpha = 1 - progress;
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.arc(x, y, 5 + progress * 10, 0, Math.PI * 2); ctx.stroke();
  }
});
